import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const load = (k, d) => { try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch { return d; } };

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => load("tce_cart", []));
  const [currency, setCurrency] = useState(() => load("tce_currency", "AED"));
  useEffect(() => localStorage.setItem("tce_cart", JSON.stringify(items)), [items]);
  useEffect(() => localStorage.setItem("tce_currency", JSON.stringify(currency)), [currency]);

  const addItem = (item) => setItems((xs) => [...xs, { ...item, key: Date.now() + Math.random() }]);
  const removeItem = (key) => setItems((xs) => xs.filter((x) => x.key !== key));
  const updateItem = (key, patch) => setItems((xs) => xs.map((x) => (x.key === key ? { ...x, ...patch } : x)));
  const clear = () => setItems([]);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateItem, clear, currency, setCurrency }}>
      {children}
    </CartContext.Provider>
  );
};
export const useCart = () => useContext(CartContext);
export const fmt = (n, ccy) => `${ccy} ${Number(n || 0).toLocaleString()}`;
export const fromPrice = (j, currency) => {
  const vals = [j.prices?.[currency]?.adult, ...(j.seasonal_prices || []).map((b) => b.prices?.[currency]?.adult)].filter((v) => v > 0);
  return vals.length ? Math.min(...vals) : null;
};
